var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContactSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "contact-success_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contact-success_svg__Rectangle_9",
    d: "M0 0h16v16H0z",
    className: "contact-success_svg__cls-1",
    transform: "translate(-.446 -.976)"
  })), /*#__PURE__*/React.createElement("style", null, ".contact-success_svg__cls-1{fill:inherit}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact-success_svg__Mask_Group_3",
    clipPath: "url(#contact-success_svg__clip-path)",
    transform: "translate(.446 .976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact-success_svg__user_9_",
    transform: "translate(0 -.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact-success_svg__Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contact-success_svg__Path_26",
    d: "M12.9 10.033a7.5 7.5 0 00-2.871-1.85 4.52 4.52 0 001.9-3.7A4.433 4.433 0 007.554 0a4.433 4.433 0 00-4.367 4.487 4.52 4.52 0 001.9 3.7 7.5 7.5 0 00-2.871 1.85A7.818 7.818 0 000 15.521h1.18a6.47 6.47 0 016.374-6.548 6.47 6.47 0 016.374 6.548h1.18a7.818 7.818 0 00-2.208-5.488zM7.554 7.76a3.235 3.235 0 01-3.187-3.273 3.235 3.235 0 013.187-3.274 3.235 3.235 0 013.187 3.274A3.235 3.235 0 017.554 7.76z",
    className: "contact-success_svg__cls-1"
  }))))));
}

export default SvgContactSuccess;